import { render, staticRenderFns } from "./AddOpportunityStatusDialog.vue?vue&type=template&id=2160c573"
import script from "./AddOpportunityStatusDialog.vue?vue&type=script&lang=js"
export * from "./AddOpportunityStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOpportunityStatusDialog.vue?vue&type=style&index=0&id=2160c573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports